import React from "react";
import "./Education.css";

const items = [
    {
        placeName: "National Institute of Technology Hamirpur",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgR-4QLYigJpD6QzIWCFvDb0We_B4uZ7unBw&usqp=CAU",
        major: "Cse Dual Degree",
        description: "9.76 CGPI",
        time: "July 2019 - Present"
    },
    {
        placeName: "Blue Bells Model School",
        major: "12th",
        image: "https://media-exp1.licdn.com/dms/image/C560BAQHBQI81Sp3sDg/company-logo_200_200/0/1593427089819?e=1628726400&v=beta&t=WrLEjbNPv5FlIM0CZ61ZVYAufWMMF8sLGgcqt0BWAi4",
        time: "2019",
        description: "94%"
    },
    {
        placeName: "Blue Bells Model School",
        major: "10th",
        image: "https://media-exp1.licdn.com/dms/image/C560BAQHBQI81Sp3sDg/company-logo_200_200/0/1593427089819?e=1628726400&v=beta&t=WrLEjbNPv5FlIM0CZ61ZVYAufWMMF8sLGgcqt0BWAi4",
        time: "2017",
        description: "10-CGPA"
    },
];


class Education extends React.Component {
    render() {
        return <div className={"education"}>
            {items.map((item, index) => {
                if (index % 2 === 0) {
                    return <div
                        key={index}
                        className={"education-card education-card-left"} style={{top: index * 200}}>
                        <img className={"education-image"} src={item.image} width={75} height={75}/>
                        <h1 className={"education-position"}>{item.major}</h1>
                        <h1 className={"education-company"}>{item.placeName}</h1>
                        <h1 className={"education-time"}>{item.time}</h1>
                        <h1 className={"education-time"}>{item.description}</h1>
                    </div>
                }
                return <div
                    key={index}
                    className={"education-card education-card-right"} style={{top: index * 200}}>
                    <img className={"education-image"} src={item.image} width={75} height={75}/>
                    <h1 className={"education-position"}>{item.major}</h1>
                    <h1 className={"education-company"}>{item.placeName}</h1>
                    <h1 className={"education-time"}>{item.time}</h1>
                    <h1 className={"education-time"}>{item.description}</h1>
                </div>
            })}
        </div>;
    }
}

export default Education;